import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CardBillWithdrawRequestPopup from './card-bill-withdraw-request-popup';
import CardBillListStore from './card-bill-list-store';
import CusEntInfoStore from '../corp-info/corp-info-store';

const CardBillWithdrawRequestPopupContainer = () => {
  // console.log('CardBillWithdrawRequestPopupContainer Load');

  const { visibleWithdrawPopup } = CardBillListStore;
  const [ withdrawInfo, setWithdrawInfo ] = useState();
  const { cusEntInfo } = CusEntInfoStore;
  const [notifyMsg, setNotifyMsg] = useState();

  useEffect(() => {
    // console.log('CardBillWithdrawRequestPopupContainer > useEffect()');

    if (visibleWithdrawPopup) {
        setWithdrawInfo({
            withdrawAmount: '',
      });
    }
  }, [ visibleWithdrawPopup, cusEntInfo ]);

  const onValueChanged = useCallback((name, e) => {
    // console.log(e);
    const { value } = e;

    setWithdrawInfo((withdrawInfo) => ({
      ...withdrawInfo,
      [name]: value,
    }));
  }, []);

  const onClickSave = useCallback(async () => {
    const withdrawFee = '1000';

    const amount = parseInt(cusEntInfo.Amount);
    const withdrawAmount = parseInt(withdrawInfo.withdrawAmount)
    
    // console.log(amount);
    // console.log(withdrawAmount);

    if (!withdrawAmount || withdrawAmount.length < 1) {
        setNotifyMsg('출금금액을 입력해주세요.');
    }
    else if (withdrawAmount > amount) {
        setNotifyMsg('출금금액이 잔액보다 큽니다.(수수료: ' +  withdrawFee + '원)');
    }

    else if (window.confirm("출금하시겠습니까?")) {
        const result = await CardBillListStore.insertCusEntWithdrawRequest(
            withdrawAmount,
        );
    
        if (result.error) {
            setNotifyMsg(result.message);
        } else {
            alert(result.message);
            setNotifyMsg('');
            CardBillListStore.setVisibleWithdrawPopup(false);
            CardBillListStore.getCardBillList();
            CardBillListStore.getCusEntAmount();
        }
    }
  }, [withdrawInfo]);

  if (!withdrawInfo) {
    return;
  }

  if (!cusEntInfo) {
    return;
  }

  return (
    <CardBillWithdrawRequestPopup
      onHiding={() => CardBillListStore.setVisibleWithdrawPopup(false)}
      onValueChanged={onValueChanged}
      onClickSave={onClickSave}
      withdrawInfo={withdrawInfo}
      cusEntInfo={cusEntInfo}
      visibleWithdrawPopup={visibleWithdrawPopup}
      notifyMsg={notifyMsg}
    />
  );
};

export default React.memo(observer(CardBillWithdrawRequestPopupContainer));
